import axios from 'axios';

import type {
  GenerateAiBuildMetaBodyT,
  GetAiBuildMetaResT,
} from 'server/controllers/experience/getAiBuildMeta';

import { P_API_AI_BUILD_META, getConfig } from 'utils';

export type { GetAiBuildMetaResT };

type GetAiBuildMetaParamsT = {
  transcript: string;
};

export async function getAiBuildMeta({
  transcript,
}: GetAiBuildMetaParamsT): Promise<GetAiBuildMetaResT> {
  const config = await getConfig();

  const res = await axios.post<GetAiBuildMetaResT>(
    P_API_AI_BUILD_META,
    {
      _csrf: config.CSRF,
      transcript,
    } satisfies GenerateAiBuildMetaBodyT,
  );

  return res.data;
}
